import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Panel del restaurante',
  tabs: {
    [Tab.OngoingOrders]: 'Preparar ahora',
    [Tab.FutureOrders]: 'Futuros',
    [Tab.CompleteOrders]: 'Completados',
  },
  buttons: {
    order_history: 'Historial de pedidos',
  },
  feedback: {
    future_orders_alert: '⚠️ No prepares aún – te avisaremos cuando debas empezar.',
  },
};
